// U2b (2026-10-09): when the server refuses a change because of the person's access level, show its
// plain-English message as a toast — many older screens only show a generic "Failed to save".
import { toast } from 'sonner';

const MARKERS = ['Ask your office administrator', 'Only the office administrator', 'Your access is'];
let last = { text: '', at: 0 };

export function maybeShowAccessNotice(status, detail) {
  if (status !== 403 || typeof detail !== 'string') return;
  if (!MARKERS.some((m) => detail.includes(m))) return;
  const now = Date.now();
  if (detail === last.text && now - last.at < 4000) return;
  last = { text: detail, at: now };
  toast.error(detail, { duration: 7000 });
}

// Screens that use fetch() directly: peek at 403 responses without consuming them.
export function installFetchAccessNotice() {
  if (typeof window === 'undefined' || window.__accessNoticeInstalled) return;
  window.__accessNoticeInstalled = true;
  const original = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await original(...args);
    if (res.status === 403) {
      res.clone().json().then((b) => maybeShowAccessNotice(403, b && b.detail)).catch(() => {});
    }
    return res;
  };
}
